module.exports = __webpack_public_path__ + "static/media/free.a6c6a35a.png";